<template>
  <div class="audio-wrap">
    <svg-icon :icon="isPlay ? 'audio' : 'audio-pause'" @click.native="playAudio" />
    <audio :src="audioUrl" ref="audio" @ended="audioEnded" style="display:none" />
  </div>
</template>
<script>
export default {
  props: {
    audios: Array
  },
  data() {
    return {
      isPlay: false
    }
  },
  computed: {
    audioUrl() {
      const { audios } = this
      if (!audios) {
        return
      }
      if (!audios.length) {
        return
      }
      const data = audios[0].html.match(/src=[\\'\\"]?([^\\'\\"]*)[\\'\\"]?/i)
      if (!data) {
        return
      }
      return data[1]
    }
  },
  beforeDestroy() {
    // 组件销毁时，停止播放
    this.close()
  },
  methods: {
    playAudio() {
      this.$nextTick(() => {
        this.isPlay ? this.pause() : this.play()
      })
    },
    /**
     * 播放结束
     */
    audioEnded() {
      this.isPlay = false
    },
    /**
     * 音频播放
     */
    play() {
      this.$refs.audio.play()
      this.isPlay = true
    },
    /**
     * 音频暂停
     */
    pause() {
      this.$refs.audio && this.$refs.audio.pause()
      this.isPlay = false
    },
    close() {
      this.$nextTick(() => {
        this.pause()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.audio-wrap {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  :deep(.svg-container) {
    cursor: pointer;
    font-size: 16px;
    vertical-align: middle;
    fill: #505873;
  }
}
</style>